let provSelect;
let provinceAvailabilities;

function init() {
  provSelect = document.getElementById('productAvailabilityProvince');
  
  if (!provSelect) { return; }
  
  provinceAvailabilities = document.querySelectorAll('.productInfo__provinceAvailability');
  provSelect.addEventListener('change', updateVisibility);
  updateVisibility();
}

function updateVisibility() {
  const selectedProvince = provSelect.value;
  provinceAvailabilities.forEach(el => el.classList.toggle('productInfo__provinceAvailability--selected', el.dataset.province === selectedProvince));
}
  
const productAvailability = { init };
export default productAvailability;